/**
 * Global sun vector normalization cache.
 * Normalizes sun direction once when it changes, avoiding per-cuboid calculations.
 */
export default class SunVector {
  static _normalized = null;
  static _lastSun = null;

  /**
   * Get normalized sun direction vector, cached globally.
   * Only recomputes when sun direction changes.
   * @returns {{x: number, y: number, z: number}} Normalized sun direction
   */
  static getNormalized() {
    const sunDir = window.sunVector || { x: 0.5, y: 0.8, z: -0.5 };
    const sunKey = `${sunDir.x},${sunDir.y},${sunDir.z}`;

    if (this._lastSun !== sunKey) {
      const mag = Math.hypot(sunDir.x, sunDir.y, sunDir.z);
      this._normalized = {
        x: sunDir.x / mag,
        y: sunDir.y / mag,
        z: sunDir.z / mag
      };
      this._lastSun = sunKey;
    }

    return this._normalized;
  }

  /**
   * Get sun intensity from global variable.
   * @returns {number} Sun intensity (0 = extreme shading, 1 = no effect)
   */
  static getIntensity() {
    return (typeof window.sunIntensity === 'number') ? window.sunIntensity : 1;
  }
}
